
import EmptyLayout from './empty.vue'

export default {
    name: 'EmptyInvert',

    components: {
        EmptyLayout,
    },
}
